"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            submitting: false,
            SSToken: null
        };
        GState.bind(this, [
            'tenant',
            'auth',
            'banner'
        ]);
        fhandler.bind(this, this.state.auth && this.state.auth.formdata || {});
    },
    onInput: function (input) {
        input.params.errmess && fhandler.alert(input.params.errmess);
    },
    onMount: async function () {
        let location;
        try {
            location = await getClientLocation();
        } catch (error) {
            console.log('Get Client Location Error: ', error);
            throw new Error('We are having trouble getting your location. Try again');
        }
        fhandler.set('country', location);
        UISocket.emit('APP::GET_SSOTOKEN', {
            authType: 'signin',
            device: window.Device,
            userAgent: window.UserAgent,
            location
        }, token => this.state.SSToken = token);
    },
    onSubmit: async function (e) {
        if (this.state.submitting)
            return;
        const Form = this.state.form;
        if (!Form.email)
            return fhandler.error('email', 'Email Address field is required');
        if (!Form.password)
            return fhandler.error('password', 'Password field is required');
        if (isDefaultDomain())
            Form.role = 'OWNER';
        Form.device = window.Device;
        const factor = window.uiStore.get('2FA-Factor');
        if (factor && factor.ignore)
            Form.ignore2FA = true;
        this.state.submitting = true;
        try {
            const {error, message, credentials, twoStep, next} = await AuthRequest('/signin', 'POST', Form);
            this.state.submitting = false;
            fhandler.alert(message, error ? 'info' : 'success');
            if (error)
                return;
            switch (next) {
            case 'grantaccess':
                twoStep ? this.twoStepAccess(twoStep, credentials) : this.grantAccess(credentials);
                break;
            case 'two-step':
                this.twoStepAccess(twoStep, credentials);
                break;
            default:
                navigate('/' + (next || 'signin'));
            }
            !error && fhandler.reset();
        } catch (error) {
            this.state.submitting = false;
            fhandler.alert(error, 'warning');
        }
    },
    createQueries: function (credentials) {
        let queries = Obj2Params(credentials);
        if (isDefaultDomain())
            queries += '&redirectTo=/onboarding';
        else {
            if (this.input.params.hasOwnProperty('redirectTo'))
                queries += '&redirectTo=' + encodeURIComponent(this.input.params.redirectTo);
        }
        return queries;
    },
    twoStepAccess: function (action, credentials) {
        if (typeof action == 'object') {
            window.uiStore.set('2FA-Factor', action.factor);
            navigate(`/two-step/verify?mtd=code&vtoken=${ action.token }`);
            return;
        }
        navigate(`/two-step?pros=${ action }&mstrict=true&2fa_agent=web&${ this.createQueries(credentials) }`);
    },
    grantAccess: function (credentials) {
        document.location = `/authorize?${ this.createQueries(credentials) }`;
    },
    onSocialSignin: function (provider) {
        if (!this.state.SSToken)
            return;
        document.location = `/${ provider }/${ this.state.SSToken }`;
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/esemu~1.0/pages/Auth/Signin.2.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_LogoImage = require("public/images/favicon/logo.png"),
    LogoImage = module_LogoImage.default || module_LogoImage,
    module_BackgroundImg = require("public/images/backgrounds/bg-grey.svg"),
    BackgroundImg = module_BackgroundImg.default || module_BackgroundImg,
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    FormAlert_template = require("../../../components/FormAlert/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    FormAlert_tag = marko_loadTag(FormAlert_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Preloader_template = require("../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    Bx_template = require("../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Wrapper_template = require("../../../components/Wrapper/index.marko"),
    Wrapper_tag = marko_loadTag(Wrapper_template),
    marko_attrs0 = {
        id: "auth-login"
      },
    marko_attrs1 = {
        "class": "col-xl-7 col-lg-9 col-12 p-2"
      },
    marko_attrs2 = {
        "class": "card-header w-100 text-center pb-0"
      },
    marko_attrs3 = {
        "class": "card-body"
      },
    marko_attrs4 = {
        "class": "mx-50"
      },
    marko_attrs5 = {
        "class": "my-2"
      },
    marko_attrs6 = {
        "class": "form-group"
      },
    marko_attrs7 = {
        "class": "form-group"
      },
    marko_attrs8 = {
        "class": "py-1"
      },
    marko_attrs9 = {
        "class": "font-small-4 ml-50 mt-4"
      },
    marko_attrs10 = {
        "class": "row m-0"
      },
    marko_attrs11 = {
        "class": "d-lg-none d-block mx-50 mt-4"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("5da300"),
    marko_node0 = marko_createElement("br", null, "7", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "8", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("p", {
        "class": "mt-4 font-small"
      }, "16", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Invalid Email Address"),
    marko_node3 = marko_createElement("p", {
        "class": "mt-4 font-small"
      }, "19", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Invalid Password"),
    marko_attrs12 = {
        "class": "col-md-6 p-50"
      },
    marko_attrs13 = {
        "class": "col-md-6 p-50"
      },
    marko_attrs14 = {
        "class": "col-md-6 p-50"
      },
    marko_attrs15 = {
        "class": "col-md-6 p-50"
      },
    marko_attrs16 = {
        "class": "d-flex align-items-center cursor-pointer border rounded"
      },
    marko_node4 = marko_createElement("img", {
        src: "/images/social/google-icon.png",
        "class": "p-1",
        style: "width:50px"
      }, "32", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node5 = marko_createElement("div", {
        "class": "d-block w-75 text-center font-medium-1"
      }, "33", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Google"),
    marko_attrs17 = {
        "class": "d-flex align-items-center cursor-pointer border rounded"
      },
    marko_node6 = marko_createElement("img", {
        src: "/images/social/facebook-icon.png",
        "class": "p-1",
        style: "width:50px"
      }, "36", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node7 = marko_createElement("div", {
        "class": "d-block w-75 text-center font-medium-1"
      }, "37", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Facebook"),
    marko_attrs18 = {
        "class": "d-flex align-items-center cursor-pointer border rounded"
      },
    marko_node8 = marko_createElement("img", {
        src: "/images/social/twitter-icon.png",
        "class": "p-1",
        style: "width:50px"
      }, "40", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node9 = marko_createElement("div", {
        "class": "d-block w-75 text-center font-medium-1"
      }, "41", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Twitter"),
    marko_attrs19 = {
        "class": "d-flex align-items-center cursor-pointer border rounded"
      },
    marko_node10 = marko_createElement("img", {
        src: "/images/social/linkedin-icon.png",
        "class": "p-1",
        style: "width:50px"
      }, "44", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node11 = marko_createElement("div", {
        "class": "d-block w-75 text-center font-medium-1"
      }, "45", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Linkedin"),
    marko_attrs20 = {
        "class": "col-xl-7 col-lg-9 col-12 px-5 py-4"
      },
    marko_node12 = marko_createElement("div", {
        style: "margin:14rem 0",
        "class": "white-text"
      }, "57", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node13 = marko_createElement("br", null, "58", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs21 = {
        "class": "font-medium-2 font-weight-300 py-2 white-text"
      },
    marko_attrs22 = {
        "class": "d-block btn btn-outline-white btn-xl text-left w-100"
      },
    marko_attrs23 = {
        "class": "position-absolute w-100 bottom-0 px-5 py-4"
      },
    marko_attrs24 = {
        "class": "list-inline m-0"
      },
    marko_attrs25 = {
        "class": "white-text"
      },
    marko_node14 = marko_createElement("li", {
        "class": "px-1 white-text"
      }, "67", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("|"),
    marko_node15 = marko_createElement("li", {
        "class": "px-1 white-text"
      }, "71", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("|"),
    marko_node16 = marko_createElement("li", {
        "class": "px-1 white-text"
      }, "75", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("|"),
    marko_node17 = marko_createElement("br", null, "55", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs26 = {
        "class": "font-large-2 white-text"
      };

const fhandler = new FormHandler({ key: 'signin-form' });

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_tag({
      scroll: true,
      renderBody: function(out) {
        out.be("section", marko_attrs0, "1", component);

        Row_tag({
            class: "m-0 no-gutters",
            col: [
                {
                    class: "col vh-100 d-flex align-items-center justify-content-end",
                    renderBody: function(out) {
                      out.be("div", marko_attrs1, "4", component);

                      out.be("div", marko_attrs2, "5", component);

                      out.e("img", {
                          src: (state.tenant && state.tenant.logo) || LogoImage,
                          style: "width:60px",
                          "class": "d-lg-none d-block rounded"
                        }, "6", component, 0);

                      if (state.auth && state.auth.message) {
                        out.n(marko_node0, component);

                        out.n(marko_node1, component);

                        out.e("p", null, "9", component, 1)
                          .t(state.auth.message, component);
                      }

                      out.ee();

                      out.be("div", marko_attrs3, "10", component);

                      FormAlert_tag({
                          alert: state.alert,
                          class: "mx-50"
                        }, out, __component, "11");

                      out.be("form", marko_attrs4, "@signin-form", component);

                      out.be("h5", marko_attrs5, "12", component);

                      Locale_tag({
                          text: "Sign In"
                        }, out, __component, "13");

                      out.ee();

                      out.be("div", marko_attrs6, "14", component);

                      out.e("input", {
                          "class": "form-control form-control-xl",
                          type: "email",
                          required: true,
                          name: "email",
                          value: state.form.email,
                          validate: fhandler.define("email"),
                          placeholder: Locale("Email Address")
                        }, "15", component, 0, 0, {
                          onchange: __component.d("change", "__onChange", false)
                        });

                      if (state.formError.email) {
                        out.n(marko_node2, component);
                      }

                      out.ee();

                      out.be("div", marko_attrs7, "17", component);

                      out.e("input", {
                          "class": "form-control form-control-xl",
                          type: "password",
                          required: true,
                          name: "password",
                          value: state.form.password,
                          placeholder: Locale("Password")
                        }, "18", component, 0, 0, {
                          onchange: __component.d("change", "__onChange", false)
                        });

                      if (state.formError.password) {
                        out.n(marko_node3, component);
                      }

                      out.ee();

                      out.be("button", {
                          type: "submit",
                          disabled: state.submitting,
                          "class": "btn btn-primary btn-xl text-left w-100"
                        }, "20", component, null, 0, {
                          onclick: __component.d("click", "onSubmit", false)
                        });

                      if (state.submitting) {
                        Preloader_tag({
                            class: "float-right font-medium-5",
                            active: true
                          }, out, __component, "21");
                      } else {
                        Bx_tag({
                            type: "right-arrow-alt",
                            class: "font-large-1 float-right white-text"
                          }, out, __component, "22");
                      }

                      Locale_tag({
                          text: "Sign In"
                        }, out, __component, "23");

                      out.ee();

                      out.be("div", marko_attrs8, "24", component);

                      route_link_tag({
                          href: "/forgotten-pwd" + (state.form.email ? "?email=" + state.form.email : ""),
                          class: "float-right",
                          renderBody: function(out) {
                            Locale_tag({
                                text: "Forgotten Password"
                              }, out, __component, "26");
                          }
                        }, out, __component, "25");

                      out.ee();

                      out.ee();

                      out.be("p", marko_attrs9, "27", component);

                      Locale_tag({
                          renderBody: function(out) {
                            out.t("Or use social login");
                          }
                        }, out, __component, "28");

                      out.ee();

                      out.e("div", marko_attrs10, "29", component, 4)
                        .e("div", marko_attrs12, "30", component, 1)
                          .e("div", marko_attrs16, "31", component, 2, 0, {
                              onclick: __component.d("click", "onSocialSignin", false, [
                                  "google"
                                ])
                            })
                            .n(marko_node4, component)
                            .n(marko_node5, component)
                        .e("div", marko_attrs13, "34", component, 1)
                          .e("div", marko_attrs17, "35", component, 2, 0, {
                              onclick: __component.d("click", "onSocialSignin", false, [
                                  "facebook"
                                ])
                            })
                            .n(marko_node6, component)
                            .n(marko_node7, component)
                        .e("div", marko_attrs14, "38", component, 1)
                          .e("div", marko_attrs18, "39", component, 2, 0, {
                              onclick: __component.d("click", "onSocialSignin", false, [
                                  "twitter"
                                ])
                            })
                            .n(marko_node8, component)
                            .n(marko_node9, component)
                        .e("div", marko_attrs15, "42", component, 1)
                          .e("div", marko_attrs19, "43", component, 2, 0, {
                              onclick: __component.d("click", "onSocialSignin", false, [
                                  "linkedin"
                                ])
                            })
                            .n(marko_node10, component)
                            .n(marko_node11, component);

                      out.be("div", marko_attrs11, "46", component);

                      Locale_tag({
                          renderBody: function(out) {
                            out.t("Don't have an account?");
                          }
                        }, out, __component, "47");

                      out.t(" ");

                      route_link_tag({
                          href: "/signup",
                          class: "text-primary",
                          renderBody: function(out) {
                            Locale_tag({
                                text: "Sign Up"
                              }, out, __component, "49");
                          }
                        }, out, __component, "48");

                      out.ee();

                      out.ee();

                      out.ee();
                    }
                  },
                {
                    class: "col p-0 d-md-flex d-none vh-100 bg-black align-items-center",
                    renderBody: function(out) {
                      out.e("div", {
                          style: marko_styleValue({
                              opacity: "0.1",
                              "background-image": ("url(\"" + (state.banner || BackgroundImg)) + "\")",
                              "background-size": "cover"
                            }),
                          "class": "position-absolute w-100 h-100"
                        }, "51", component, 0, 1);

                      out.be("div", marko_attrs20, "52", component);

                      out.e("div", null, "53", component, 3)
                        .e("img", {
                            src: (state.tenant && state.tenant.logo) || LogoImage,
                            style: "width:60px",
                            "class": "rounded-lg"
                          }, "54", component, 0)
                        .n(marko_node17, component)
                        .e("h1", marko_attrs26, "56", component, 1)
                          .t(state.tenant.name, component);

                      out.n(marko_node12, component);

                      out.n(marko_node13, component);

                      out.be("p", marko_attrs21, "59", component);

                      Locale_tag({
                          renderBody: function(out) {
                            out.t("Don't have an account?");
                          }
                        }, out, __component, "60");

                      out.ee();

                      out.be("button", marko_attrs22, "61", component, null, 0, {
                          onclick: __component.d("click", () => navigate('/signup'), false)
                        });

                      Bx_tag({
                          type: "right-arrow-alt",
                          class: "font-large-1 float-right white-text"
                        }, out, __component, "62");

                      Locale_tag({
                          text: "Sign Up"
                        }, out, __component, "63");

                      out.ee();

                      out.ee();

                      out.be("div", marko_attrs23, "64", component);

                      out.be("ul", marko_attrs24, "65", component);

                      out.e("li", marko_attrs25, "66", component, 4)
                        .t("Copyright © ")
                        .t((new Date()).getFullYear(), component)
                        .t(" ")
                        .t(state.tenant ? state.tenant.name : "Multipple, Inc", component);

                      out.n(marko_node14, component);

                      out.be("li", null, "68", component);

                      route_link_tag({
                          renderBody: function(out) {
                            Locale_tag({
                                text: "Privacy Policy",
                                class: "white-text"
                              }, out, __component, "70");
                          }
                        }, out, __component, "69");

                      out.ee();

                      out.n(marko_node15, component);

                      out.be("li", null, "72", component);

                      route_link_tag({
                          renderBody: function(out) {
                            Locale_tag({
                                text: "Cookies Policy",
                                class: "white-text"
                              }, out, __component, "74");
                          }
                        }, out, __component, "73");

                      out.ee();

                      out.n(marko_node16, component);

                      out.be("li", null, "76", component);

                      route_link_tag({
                          renderBody: function(out) {
                            Locale_tag({
                                text: "Terms",
                                class: "white-text"
                              }, out, __component, "78");
                          }
                        }, out, __component, "77");

                      out.ee();

                      out.ee();

                      out.ee();
                    }
                  }
              ]
          }, out, __component, "2");

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
